import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const Column = props => {
  const list = props.listItems.map(item => {
    const isDisabled = !item.selected && props.disabled
    return (
      <li key={item.id} className='checkbox-wrapper drop-down__aircraft-item'>
        <span
          className={classnames([
            'flex-container align-middle drop-down__label',
            {
              'drop-down__label--disabled': isDisabled,
            },
          ])}
        >
          <input
            className='checkbox__input drop-down__input drop-down__input--aircraft'
            type='checkbox'
            checked={item.selected}
            onChange={() => props.onItemClick(item.id)}
            disabled={isDisabled}
          />
          {/* <span
            className={classnames([
              'checkbox__fake drop-down__fake-checkbox',
              {
                'drop-down__fake-checkbox--disabled': isDisabled,
              },
            ])}
          >
            <svg width='10' height='10' viewBox='0 0 10 10'>
              <polyline points='2,5 4,7 8,3'></polyline>
            </svg>
          </span> */}
          <span
            className={classnames([
              'drop-down__fleet-item-title drop-down__fleet-item-title--zero-padding-left drop-down__aircraft-item-title',
              {
                'drop-down__fleet-item-title--active': item.selected,
                'drop-down__fleet-item-title--disabled': isDisabled,
              },
            ])}
          >
            {item.name}
          </span>
        </span>
      </li>
    )
  })

  const columnIsActive =
    props.selected || props.listItems.some(el => el.selected)
  const isDisabled = !columnIsActive && props.disabled

  return (
    <div className='flex-container flex-dir-column drop-down__fleet-container'>
      <div className='checkbox-wrapper drop-down__fleet-item'>
        <label
          className={classnames([
            'flex-container align-top drop-down__label',
            {
              'drop-down__label--disabled': isDisabled,
            },
          ])}
        >
          <input
            className='checkbox__input drop-down__input'
            type='checkbox'
            checked={props.selected}
            onChange={props.onMainItemClick}
            disabled={isDisabled}
          />
          <span className='checkbox__fake drop-down__fake-checkbox'>
            <svg width='10' height='10' viewBox='0 0 10 10'>
              <polyline points='2,5 4,7 8,3'></polyline>
            </svg>
          </span>
          <span
            className={classnames([
              'drop-down__fleet-item-title',
              'drop-down__fleet-item-title--brand',
              {
                'drop-down__fleet-item-title--active': columnIsActive,
                'drop-down__fleet-item-title--disabled': isDisabled,
              },
            ])}
          >
            {props.title}
          </span>
        </label>
        <p
          className={classnames([
            'drop-down__fleet-item-info',
            {
              'drop-down__fleet-item-info--active': columnIsActive,
            },
          ])}
        >
          {props.info}
        </p>
      </div>
      <ul className='flex-container flex-dir-column drop-down__fleet-list'>
        {list}
      </ul>
    </div>
  )
}

Column.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.bool.isRequired,
  info: PropTypes.string,
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
    }).isRequired
  ),
  onItemClick: PropTypes.func.isRequired,
  onMainItemClick: PropTypes.func.isRequired,
  title: PropTypes.string,
}

export default Column
